import React, { useEffect, useState, useRef } from "react";
import configs from "../Constants";
import axios from "axios";
import TablePagination from "@mui/material/TablePagination";
import SearchIcon from "@mui/icons-material/Search";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-responsive-list";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  Box,
  TextField,
  Button,
  DialogActions,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import DeleteDiaologue from "./sub_comp/Delete";
import { printReceipt } from "./util";
import { useIntl } from "react-intl";
import Currencies from "../root/currency";
const Customers = () => {
  const [customerData, setCustomerData] = useState([]);
  const [editedData, setEditedData] = useState([]);
  const [name, setName] = useState("");
  const [mobileNo, setMoblileNo] = useState(0);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [edit, setEdit] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const [filterPro, setFilterPro] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [openView, setOpenView] = useState(false);
  const [customerOrders, setCustomerOrders] = useState([]);
  const [totalSpent, setTotalSpent] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);

  let domain =
    window.location.href.indexOf("localhost") > 0
      ? "https://menu.merchantnations.com"
      : window.location.origin;

  let merchantData = sessionStorage.getItem("merchantData")
    ? JSON.parse(sessionStorage.getItem("merchantData"))
    : null;
  const merchCode = merchantData ? merchantData.merchantCode : "";
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  console.log(userData);
  const userId = userData ? userData.sub : " ";
  let baseURL = configs.baseURL;
  let authApi = configs.authapi;
  let menuApi = configs.menuapi;
  const { formatMessage: t } = useIntl();

  // Currency formatter
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });

  console.log(`${authApi}/api/customer/${userId}`);

  let userToken = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : "";
  // let userToken =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2NTZmMmE2ODc0YTRkNjIzYmJlM2Q1ODAiLCJyb2xlIjoiQWRtaW4iLCJpYXQiOjE3NDQyNjUxNTAsImV4cCI6MTc0NDg2OTk1MH0.NmI9JEM2gChfmIL9R8eR3XVpjLom4PUdKx0NTD_0bCE";
  console.log(userToken);
  const getCustomerList = () => {
    // console.log("This is the token: " + userToken)
    // console.log("This is the api that is calling from the customers end : " + `${authApi}/customer?merchantCode=${merchCode}`)
    axios({
      method: "get",
      url: `${authApi}/user/customers?merchantCode=${merchCode}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }).then((res) => {
      console.log(res.data);
      setCustomerData(res.data);
    });
  };
  useEffect(() => {
    if (!customerData.length) {
      getCustomerList();
    }
  }, []);
  const handleSubmit = () => {
    console.log(mobileNo);
    axios
      .put(`${authApi}/customer/${editedData.id}`, {
        phone: mobileNo !== 0 ? mobileNo : editedData.phone,
        firstName: name !== "" ? name : editedData.firstName,
        address: address !== "" ? address : editedData.address,
        email: email !== "" ? email : editedData.email,
      })
      .then((res) => {
        console.log(res.data);
        setEdit(false);
        getCustomerList();
      });
  };
  const handleDelete = (id) => {
    // console.log(id);
    // axios.delete(`https://authapi.digitallive24.com/customer/${deleteItemId}`).then((response) => {
    //     getCustomerList();
    // });
    const customer = customerData.find((cust) => cust.id === id);
    setDeleteItemName(customer?.firstName || "this customer");
    setDeleteItemId(id);
    setOpenDeleteDialog(true);
  };
  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleConfirmDelete = () => {
    if (deleteItemId) {
      axios.delete(`${authApi}/customer/${deleteItemId}`).then((response) => {
        getCustomerList();
      });
    }
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleEdit = async (id) => {
    // setEdit(true);
    console.log(id);
    try {
      if (id) {
        await axios.get(`${authApi}/customer/${id}`).then((res) => {
          console.log(res.data);
          const data = res.data;
          setEditedData(data);

          setName(data.firstName || "");
          setMoblileNo(data.phone || "");
          setAddress(data.address || "");
          setEmail(data.email || "");
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setEdit(true);
    }
  };
  const filterCustomers = (e) => {
    console.log(customerData);
    let val = e.target.value;
    let fltData = customerData.filter(
      (pro) =>
        pro.firstName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
        pro.phone.indexOf(val.toLowerCase()) !== -1 ||
        pro.email.indexOf(val.toLowerCase()) !== -1 ||
        pro.address.indexOf(val.toLowerCase()) !== -1
    );
    setFilterPro(fltData);
    setIsSearch(val ? true : false);
  };
  // const handleView = async (id) => {
  //   console.log("Testing Customer Report API:", id);

  //   axios
  //     .get(`${configs.baseURL}/api/orders/customer/${id}`, {
  //       headers: {
  //         Authorization: `Bearer ${userToken}`,
  //       },
  //     })
  //     .then((res) => {
  //       console.log("API Working:", res.data);
  //       // later: show popup here
  //     })
  //     .catch((err) => {
  //       console.log("API Error:", err);
  //     });
  // };
  const handleView = async (customerId) => {
    try {
      const res = await axios.get(
        `${configs.baseURL}/api/orders/customer/${customerId}`,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      let orders = res.data;

      // If API returns nested arrays, flatten them
      orders = orders.flat();

      setCustomerOrders(orders);

      // 1️⃣ Total Spent Calculation
      const total = orders.reduce((sum, order) => sum + (order.totalPrice || 0), 0);
      setTotalSpent(total);

      // 2️⃣ Pending Payments (isPaid === false)
      const pending = orders
        .filter((order) => order.isPaid === false)
        .reduce((sum, order) => sum + (order.totalPrice || 0), 0);

      setPendingAmount(pending);

      setOpenView(true);
    } catch (err) {
      console.log("API Error:", err);
    }
  };


  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleMobileNo = (e) => {
    setMoblileNo(e.target.value);
  };
  const handleAddress = (e) => {
    setAddress(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleClose = () => {
    setEdit(false);
  };
  const printRef = useRef();
  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;

    const newWindow = window.open("", "", "width=900,height=700");

    newWindow.document.write(`
    <html>
      <head>
        <title>Customer Order History</title>
        <style>
          body { font-family: Arial, Helvetica, sans-serif; padding: 20px; }

          h2, h3, h4, p { margin: 4px 0; }

          .order-box {
            border: 1px solid #ddd;
            padding: 12px;
            margin-bottom: 20px;
            border-radius: 8px;
          }

          .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }

          .items-table th {
            text-align: left;
            padding: 6px;
            background: #f2f2f2;
            font-weight: bold;
            border-bottom: 1px solid #ccc;
          }

          .items-table td {
            padding: 6px;
            border-bottom: 1px solid #eee;
          }

        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  let productItems = isSearch ? filterPro : customerData;
  return (
    <div className="container">
      <div className="header">
        <h4>Customers</h4>
        <div className="search">
          <SearchIcon />
          <input
            type="text"
            onChange={filterCustomers}
            placeholder="Enter Customer Details"
            style={{
              border: "none",
              outline: "none",
              width: "87%",
              backgroundColor: "transparent",
            }}
          />
        </div>
      </div>
      <div className="product-list">
        <Table width="100%" cellPadding="4px">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Mobile Number</Th>
              <Th>Address</Th>
              <Th>Email ID</Th>
              <Th>Created Date</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {productItems.length
              ? productItems
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((customer) => {
                  return (
                    <Tr
                      style={{
                        borderBottom: "1px solid #f0eeee",
                        margin: "5px",
                      }}
                    >
                      <Td>{customer.firstName}</Td>
                      <Td>{customer.phone}</Td>
                      <Td>{customer.address}</Td>
                      <Td>{customer.email}</Td>
                      <Td>
                        {moment(customer.createdDate).format(
                          "h:mm a  DD MMM YYYY"
                        )}
                      </Td>
                      <Td>
                        <Td align="center">
                          <IconButton
                            aria-label="delete"
                            size="large"
                            color="info"
                            onClick={() => handleEdit(customer.id)}
                          >
                            <EditIcon />
                          </IconButton>
                        </Td>
                        <Td align="center">
                          <IconButton
                            aria-label="view"
                            size="large"
                            color="primary"
                            onClick={() => handleView(customer.id)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Td>

                        <Td align="center">
                          {/* <button className='btn btn-danger' onClick={()=> handleDelete(p.id)}><DeleteIcon/></button> */}
                          <IconButton
                            aria-label="delete"
                            size="large"
                            color="error"
                            onClick={() => handleDelete(customer.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Td>
                      </Td>
                    </Tr>
                  );
                })
              : ""}
          </Tbody>
        </Table>
        {customerData && customerData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={customerData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </div>
      {openDeleteDialog === true ? (
        <DeleteDiaologue
          open={openDeleteDialog}
          onClose={handleDeleteClose}
          onConfirm={handleConfirmDelete}
          itemName={deleteItemName}
        />
      ) : (
        <div />
      )}
      <Dialog open={edit} onClose={handleClose} maxWidth="md">
        <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Customer Data
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <form
            style={{
              padding: "18px",
              paddingLeft: "18px",
              paddingTop: "5px",
            }}
          >
            <div className="row">
              <div>
                <Box
                  sx={{ width: 500, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Name</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    onChange={handleName}
                    value={name}
                  />
                </Box>
              </div>

              <div>
                <Box
                  sx={{ width: 300, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Mobile Number</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    type="number"
                    onChange={handleMobileNo}
                    name="Mobile Number"
                    value={mobileNo}
                  />
                </Box>
              </div>
            </div>

            <div className="row">
              <div>
                <Box
                  sx={{ width: 500, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Address</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    onChange={handleAddress}
                    value={address}
                  />
                </Box>
              </div>

              <div>
                <Box
                  sx={{ width: 500, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Email Id</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    onChange={handleEmail}
                    name="description"
                    value={email}
                  />
                </Box>
              </div>
            </div>
          </form>
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            color="error"
            style={{ margin: "8px" }}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="success"
            style={{ margin: "8px", background: "#f7c919" }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openView} onClose={() => setOpenView(false)} maxWidth="lg" fullWidth>

        {/* ------------------ TITLE ------------------ */}
        <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
          Customer Purchase Report
        </DialogTitle>

        {/* ------------------ ACTIONS (Print + Close) ------------------ */}
        <DialogActions>
          <Button
            variant="contained"
            onClick={handlePrint}
            color="primary"
            style={{ background: "#1976d2", marginRight: "10px" }}
          >
            PRINT HISTORY
          </Button>

          <Button variant="outlined" color="error" onClick={() => setOpenView(false)}>
            CLOSE
          </Button>
        </DialogActions>

        {/* ------------------ CONTENT (Print Ref) ------------------ */}
        <DialogContent dividers ref={printRef}>

          {/* PRINT CSS */}
          <style>
            {`
        /* Hide UI table in print mode */
        @media print {
          .ui-table { display: none !important; }
          .print-table { display: block !important; }
        }

        /* Hide print table in UI mode */
        .print-table { display: none; }

        .order-box {
          border: 1px solid #ddd;
          border-radius: 10px;
          padding: 15px;
          background: #fafafa;
          margin-bottom: 20px;
        }
      `}
          </style>

          {/* ------------------ TOTAL SUMMARY ------------------ */}
          <h3>Total Purchase: <strong>${totalSpent.toFixed(2)}</strong></h3>

          <h4 style={{ color: pendingAmount > 0 ? "red" : "green" }}>
            Pending Payment: <strong>${pendingAmount.toFixed(2)}</strong>
          </h4>

          {/* ------------------ ORDER LIST ------------------ */}
          {customerOrders.length === 0 ? (
            <p style={{ textAlign: "center", padding: "20px" }}>
              This customer has no order history.
            </p>
          ) : (
            customerOrders.map((order) => (
              <Box className="order-box" key={order.id}>

                <h3>Order #{order.number || "N/A"} — ${order.totalPrice}</h3>

                <p><strong>Date:</strong> {moment(order.createdAt).format("DD MMM YYYY, h:mm a")}</p>

                <p>
                  <strong>Payment:</strong>{" "}
                  <span style={{ color: order.isPaid ? "green" : "red" }}>
                    {order.isPaid ? "Paid" : "Pending"}
                  </span>
                </p>

                <h4>Items:</h4>

                <IconButton
                  aria-label="print"
                  size="small"
                  color="primary"
                  onClick={() => printReceipt(order, merchantData, [], t, formatter)}
                  style={{ float: "right", marginTop: "-40px" }}
                >
                  <PrintIcon />
                </IconButton>

                <Table className="ui-table" width="100%" cellPadding="4px">
                  <Thead>
                    <Tr>
                      <Th>Item Name</Th>
                      <Th>Quantity</Th>
                      <Th>Price</Th>
                    </Tr>
                  </Thead>

                  <Tbody>
                    {order.orderItems?.map((item) => (
                      <Tr key={item._id}>
                        <Td>{item.name}</Td>
                        <Td>{item.quantity}</Td>
                        <Td>${item.price}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>

                <div
                  className="print-table"
                  dangerouslySetInnerHTML={{
                    __html: `
                <table style="width:100%; border-collapse: collapse; margin-top:10px;">
                  <thead>
                    <tr style="background:#f2f2f2;">
                      <th style="padding:8px; text-align:left;">Item Name</th>
                      <th style="padding:8px; text-align:left;">Quantity</th>
                      <th style="padding:8px; text-align:left;">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${order.orderItems
                        .map(
                          (item) => `
                          <tr>
                            <td style="padding:6px;">${item.name}</td>
                            <td style="padding:6px;">${item.quantity}</td>
                            <td style="padding:6px;">$${item.price}</td>
                          </tr>
                        `
                        )
                        .join("")}
                  </tbody>
                </table>
              `,
                  }}
                ></div>
              </Box>
            ))
          )}

        </DialogContent>



      </Dialog>



    </div>
  );
};

export default Customers;
